import { SettingsTrustedIpsDto } from '@sr/dto';
import { settingsApi } from '../api';

export const useTrustedIpsSettings = () => {
  const { data, isLoading, error } = settingsApi.useGetTrustedIpsSettingsQuery(undefined, { refetchOnMountOrArgChange: 120 });
  const [set] = settingsApi.useSetTrustedIpsSettingsMutation();

  return {
    data: { trustedIps: data?.trustedIps ?? [], enabled: data?.enabled ?? false, id: 1 },
    isLoading,
    error,
    update: (dto: SettingsTrustedIpsDto) => set(dto).unwrap()
  };
};
